export default ['submitted', 'approved', 'rejected'];
